<div class="content">
  <h1 class="title">
    {{ 'CHECK_PRODUCTION_DATE_PAGE.TITLE' | translate }}
  </h1>

  <app-check-production-dates-form
    (formSubmitted)="onFormSubmitted($event)"
  ></app-check-production-dates-form>

  <app-check-production-dates-result
    *ngIf="checkProductionDateParams"
    [checkProductionDateParams]="checkProductionDateParams"
    (clear)="onClearResult()"
  ></app-check-production-dates-result>
  <app-check-production-dates-info></app-check-production-dates-info>
</div>
